// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__EA8Mz","row":"Node_row__BiGSy","label":"Node_label__2yVAx","footer":"Node_footer__1j-FN"};